import { paymentsApi } from './api'
import { useLanguage } from '../hooks/useLanguage'
import toast from 'react-hot-toast'

export const stripeService = {
  /**
   * Gestisce il pagamento di una tranche (prima o seconda)
   * @param trancheType - Tipo di tranche ('first' | 'second')
   * @param bookingId - ID della prenotazione
   * @returns Promise<void>
   */
  handlePayment: async (trancheType: 'first' | 'second', bookingId: string, codiceScontoId?: string): Promise<void> => {
    try {
      // Chiama il backend per creare la sessione di checkout
      const response = await paymentsApi.createPayment(bookingId, trancheType, codiceScontoId)

      // Reindirizza direttamente all'URL di checkout fornito dal backend
      if (response.checkoutUrl) {
        window.location.href = response.checkoutUrl
      } else {
        throw new Error('Nessun URL di checkout disponibile')
      }
    } catch (error: any) {
      console.error('Errore durante il pagamento:', error)
      
      // Gestisci l'errore di posti insufficienti
      if (error.response?.data?.message === 'insufficient_spots') {
        const availableSpots = error.response.data.availableSpots
        const requestedSpots = error.response.data.requestedSpots
        
        // Mostra un toast con il messaggio di errore
        toast.error(`Ci dispiace, troppo tardi! Non ci sono più posti disponibili per questo viaggio. Sono rimasti solo ${availableSpots} posti.`, {
          duration: 8000,
          style: {
            background: '#fee2e2',
            color: '#dc2626',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            padding: '16px',
            fontSize: '14px',
            maxWidth: '500px'
          }
        })
        
        // Lancia un errore specifico per essere gestito dal componente
        throw new Error('INSUFFICIENT_SPOTS')
      }
      
      throw error
    }
  },

  /**
   * Verifica se il servizio di pagamento è disponibile
   * @returns Promise<boolean>
   */
  isStripeAvailable: async (): Promise<boolean> => {
    try {
      // Verifica che il backend sia raggiungibile
      await paymentsApi.getUserBookings()
      return true
    } catch {
      return false
    }
  }
} 